// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* navbar */
nav.navbar {
  padding-right: 50px;
  background: #ffffff;
  border: 1px solid #dddddd;
  box-shadow: none;
  min-height: 70px;
  display: flex;
  align-items: center;
}

div.navbar-header {
  padding-left: 15px;
  flex: 1 1;
  display: flex;
}

ul.navbar-right li {
  height: 50px;
  display: flex;
  align-items: center;
}

/* ── Apply Loan / New Saving button ── */
li button.request_loan {
  display: inline-flex;
  align-items: center;
  background: rgb(243, 35, 35) !important;
  color: #fff;
  border: 0;
  border-radius: 8px;
  padding: 7px 16px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  cursor: pointer;
}

li button.request_loan:hover {
  background: rgb(243, 35, 35) !important;
}

/* ── User avatar (initials circle) ── */
div.profile {
  display: flex;
  height: 42px;
  align-items: center;
  cursor: pointer;
  margin-left: 24px;
  position: relative;
  padding: 4px 10px;
  border-radius: 8px;
  transition: background 0.12s;
}

div.profile:hover {
  background: #f1f5f9;
}

div.user-avatar-initials {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
  letter-spacing: 0.03em;
}

div.user-info {
  display: flex;
  flex-direction: column;
  margin-left: 9px;
  margin-right: 8px;
  line-height: 1.2;
}

span.user-name {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
  max-width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
}

span.user-role {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 400;
}

i.user-chevron {
  font-size: 11px;
  color: #94a3b8;
}

/* ── Dropdown ── */
div.dropdown {
  position: absolute;
  background: white;
  border: 1px solid #e2e8f0;
  top: 54px;
  right: 0;
  border-radius: 10px;
  min-width: 240px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.10);
  overflow: hidden;
  z-index: 1000;
}

div.dropdown-user-header {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  gap: 12px;
}

div.dropdown-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
}

div.dropdown-user-meta {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

div.dropdown-user-meta strong {
  font-size: 13px;
  color: #0f172a;
}

div.dropdown-user-meta span {
  font-size: 11px;
  color: #64748b;
}

div.dropdown ul {
  padding: 6px 0;
  margin: 0;
  list-style: none;
}

div.dropdown ul li {
  height: 44px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  font-size: 13px;
  color: #374151;
  border: 0;
  cursor: pointer;
  transition: background 0.1s;
}

div.dropdown ul li:hover {
  background: #f8fafc;
}

li.signout-li {
  border-top: 1px solid #e2e8f0 !important;
  color: #ef4444 !important;
  margin-top: 4px;
}

div.dropdown ul li a {
  text-decoration: none;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

/* ── Navbar brand ── */
.navbar-brand a {
  padding-right: 15px;
  color: black;
  opacity: 0.9;
}

.navbar-brand span {
  text-transform: capitalize;
}

.app_mobile_menus {
  display: none !important;
}

@media only screen and (max-width: 600px) {
  .app_mobile_menus {
    display: block !important;
  }
  div.user-info {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App/components/Navbar/styles.css"],"names":[],"mappings":"AAAA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uCAAuC;EACvC,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;EACd,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* navbar */\nnav.navbar {\n  padding-right: 50px;\n  background: #ffffff;\n  border: 1px solid #dddddd;\n  box-shadow: none;\n  min-height: 70px;\n  display: flex;\n  align-items: center;\n}\n\ndiv.navbar-header {\n  padding-left: 15px;\n  flex: 1;\n  display: flex;\n}\n\nul.navbar-right li {\n  height: 50px;\n  display: flex;\n  align-items: center;\n}\n\n/* ── Apply Loan / New Saving button ── */\nli button.request_loan {\n  display: inline-flex;\n  align-items: center;\n  background: rgb(243, 35, 35) !important;\n  color: #fff;\n  border: 0;\n  border-radius: 8px;\n  padding: 7px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n}\n\nli button.request_loan:hover {\n  background: rgb(243, 35, 35) !important;\n}\n\n/* ── User avatar (initials circle) ── */\ndiv.profile {\n  display: flex;\n  height: 42px;\n  align-items: center;\n  cursor: pointer;\n  margin-left: 24px;\n  position: relative;\n  padding: 4px 10px;\n  border-radius: 8px;\n  transition: background 0.12s;\n}\n\ndiv.profile:hover {\n  background: #f1f5f9;\n}\n\ndiv.user-avatar-initials {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n  letter-spacing: 0.03em;\n}\n\ndiv.user-info {\n  display: flex;\n  flex-direction: column;\n  margin-left: 9px;\n  margin-right: 8px;\n  line-height: 1.2;\n}\n\nspan.user-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0f172a;\n  white-space: nowrap;\n  max-width: 130px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\nspan.user-role {\n  font-size: 10px;\n  color: #94a3b8;\n  font-weight: 400;\n}\n\ni.user-chevron {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n/* ── Dropdown ── */\ndiv.dropdown {\n  position: absolute;\n  background: white;\n  border: 1px solid #e2e8f0;\n  top: 54px;\n  right: 0;\n  border-radius: 10px;\n  min-width: 240px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.10);\n  overflow: hidden;\n  z-index: 1000;\n}\n\ndiv.dropdown-user-header {\n  display: flex;\n  align-items: center;\n  padding: 14px 16px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  gap: 12px;\n}\n\ndiv.dropdown-avatar {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\ndiv.dropdown-user-meta {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.3;\n}\n\ndiv.dropdown-user-meta strong {\n  font-size: 13px;\n  color: #0f172a;\n}\n\ndiv.dropdown-user-meta span {\n  font-size: 11px;\n  color: #64748b;\n}\n\ndiv.dropdown ul {\n  padding: 6px 0;\n  margin: 0;\n  list-style: none;\n}\n\ndiv.dropdown ul li {\n  height: 44px;\n  display: flex;\n  align-items: center;\n  padding: 0 16px;\n  font-size: 13px;\n  color: #374151;\n  border: 0;\n  cursor: pointer;\n  transition: background 0.1s;\n}\n\ndiv.dropdown ul li:hover {\n  background: #f8fafc;\n}\n\nli.signout-li {\n  border-top: 1px solid #e2e8f0 !important;\n  color: #ef4444 !important;\n  margin-top: 4px;\n}\n\ndiv.dropdown ul li a {\n  text-decoration: none;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n/* ── Navbar brand ── */\n.navbar-brand a {\n  padding-right: 15px;\n  color: black;\n  opacity: 0.9;\n}\n\n.navbar-brand span {\n  text-transform: capitalize;\n}\n\n.app_mobile_menus {\n  display: none !important;\n}\n\n@media only screen and (max-width: 600px) {\n  .app_mobile_menus {\n    display: block !important;\n  }\n  div.user-info {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
